// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class HubV1SearchPatientsDefaultResponse {
    static getAttributeTypeMap() {
        return HubV1SearchPatientsDefaultResponse.attributeTypeMap;
    }
}
HubV1SearchPatientsDefaultResponse.discriminator = undefined;
HubV1SearchPatientsDefaultResponse.additionalProperties = false;
HubV1SearchPatientsDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
];
//# sourceMappingURL=hubV1SearchPatientsDefaultResponse.js.map